/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Hotel_Lobby_TitleInputs */

const en_admin_settings_groups_hotel_lobby_title = /** @type {(inputs: Admin_Settings_Groups_Hotel_Lobby_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rap video generator`)
};

/**
* | output |
* | --- |
* | "Rap video generator" |
*
* @param {Admin_Settings_Groups_Hotel_Lobby_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_hotel_lobby_title = /** @type {((inputs?: Admin_Settings_Groups_Hotel_Lobby_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Hotel_Lobby_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_hotel_lobby_title(inputs)
});
export { admin_settings_groups_hotel_lobby_title as "admin.settings.groups.hotel_lobby.title" }